<p-dataView *ngIf="dataView" #dv [value]="products" [paginator]="true" [rows]="9" filterBy="posVendorName" layout="grid">
    <ng-template pTemplate="header">
        <div class="p-d-flex p-flex-column p-flex-md-row p-jc-md-between">
            <span class="p-input-icon-left p-mb-2 p-mb-md-0">
                <i class="pi pi-search"></i>
                <input type="search" pInputText placeholder="Search by Name" (input)="dv.filter($event.target.value)">
            </span>
            <p-dataViewLayoutOptions></p-dataViewLayoutOptions>
        </div>
    </ng-template>
    <ng-template let-productLists pTemplate="list">
        <div class="p-grid">
            <div *ngFor="let product of productLists" class="p-col-12">
                <p-card class="product-item">
                    <div class="p-d-flex p-jc-between">
                        <div class="p-text-center">
                            <img [src]="product.imageUrl" [alt]="product.posVendorName"/>
                            <div class="p-mt-2"><strong>{{product.posVendorName}}</strong></div>
                        </div>
                        <div class="p-d-flex p-flex-column p-text-right">
                            <div>
                                <p-button label="Install" (click)="installBtn(product)" *ngIf="product.posConsumerId"></p-button>
                                <span class="pi pi-spin pi-spinner" *ngIf="product.showSpin"></span>
                                <p-button icon="pi pi-check" (click)="uninstallBtn(product)" *ngIf="!product.posConsumerId"></p-button>
                            </div>
                            <p-button class="p-mt-auto" label="Details" (click)="changeTableView(product)" *ngIf="product.isInstalled"></p-button>
                        </div>
                    </div>
                    <div class="p-mt-2 leaddescName" (click)="showMoreInfo(product)">
                        {{(product.description.length>22) ? (product.description | slice:0:22) + '... More' : product.description}}
                    </div>
                </p-card>
            </div>
        </div>
    </ng-template>
    <ng-template let-productLists pTemplate="grid">
        <div class="p-grid">
            <div *ngFor="let product of productLists" class="p-col-12 p-md-4">
                <p-card class="product-item">
                    <div class="p-d-flex p-jc-between">
                        <div class="p-text-center">
                            <img [src]="product.imageUrl" [alt]="product.posVendorName"/>
                            <div class="p-mt-2"><strong>{{product.posVendorName}}</strong></div>
                        </div>
                        <div>
                            <p-button label="Install" (click)="installBtn(product)" *ngIf="!product.isInstalled"></p-button>
                            <span class="pi pi-spin pi-spinner" *ngIf="product.showSpin"></span>
                            <p-button icon="pi pi-check" (click)="uninstallBtn(product)" *ngIf="product.isInstalled"></p-button>
                        </div>
                    </div>
                    <div class="p-d-flex p-jc-between">
                        <div class="p-mt-2 leaddescName" (click)="showMoreInfo(product)">
                            {{(product.description.length>22) ? (product.description | slice:0:22) + '... More' : product.description}}
                        </div>
                        <div>
                            <p-button label="Details" (click)="changeTableView(product)" *ngIf="product.isInstalled"></p-button>
                        </div>
                    </div>
                </p-card>
            </div>
        </div>
    </ng-template>
</p-dataView>
<ng-container *ngIf="!dataView">
    <div class="table-header p-d-flex">
        <p-button icon="pi pi-arrow-left" label="Back" (click)="backDataView()"></p-button>
        <h5 class="p-ml-3 p-mt-1">Point of Sale (POS)</h5>
    </div>

    <p-tabView (onChange)="onTabChange($event)" [(activeIndex)]="invActiveIndex">
        <p-tabPanel header="Setup">
            <p-fieldset *ngIf="vendorCredentials"  legend="Vendor Credentials">
                <form  [formGroup]="vendorCredentialsForm">
                    <div class="p-grid">
                        <div class="p-col-3">
                            <div class="p-mt-2">Identity Code:</div>
                        </div>
                        <div class="p-col-6">
                            <input class="w-100" type="text" formControlName="identityCode" [readonly]="isEdit" pInputText >
                        </div>
                    </div>
                </form>
                <div class="p-text-right">
                    <p-button label="Edit" class="p-mr-2" (click)="isEdit = false" *ngIf="isEdit"></p-button>
                    <p-button label="Save"  *ngIf="!isEdit"  [disabled]="!vendorCredentialsForm.valid" (click)="saveVendorCredentials(vendorCredentialsForm.value)"></p-button>
                </div>
            </p-fieldset>

          <p-fieldset legend="POS Field ID" >
                <div class="p-grid" *ngFor="let item of posVendorInfo ; let i = index">
                    <div class="p-col-3">
                        <div class="p-mt-0">{{item.posVendorFieldName}}<span *ngIf="item.isRequired" style="color: red">*</span>:</div>
                    </div>
                    <div class="p-col-6">

                        <p-dropdown [options]="fields" placeholder="Select Field" optionValue="id" appendTo="body" [(ngModel)]="item.mappedCustomAttributeId" optionLabel="name" styleClass="w-100"></p-dropdown>

                    </div>
                </div>
                <div class="p-text-right">
                    <p-button label="Edit" class="p-mr-2" (click)="isEdit2 = true" *ngIf="!isEdit2"></p-button>
                    <p-button label="Save" (click)="saveField2()"  [disabled]="isSaveDisabled()"></p-button>
                </div>
         </p-fieldset>

        </p-tabPanel>
        <p-tabPanel header="Field Mapping" >
            <p-table [value]="fieldMappingListing" responsiveLayout="scroll" styleClass="p-datatable-gridlines">
                <ng-template pTemplate="header">
                    <tr>
                        <th>Channel Name</th>
                        <th>Module Name</th>
                        <th>POS Data Count</th>
                        <th>Mapped</th>
                        <th>Not Mapped</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-product>
                    <tr>
                        <td>{{product.channelName}}</td>
                        <td>{{product.moduleName}}</td>
                        <td>
                            <span class="pointer" (click)="showDataTB('pos','')">{{product.posDataCount}}</span>
                        </td>
                        <td>
                            <span class="pointer" (click)="showDataTB('map',product.channelId)">{{product.mappedData}}</span>
                        </td>
                        <td>
                            <span class="pointer" (click)="showDataTB('notmap','')">{{product.notMappedData}}</span>
                        </td>

                    </tr>
                </ng-template>
            </p-table>
        </p-tabPanel>
        <p-tabPanel *ngIf="invActiveIndex != 0" headerStyleClass="iconPanel">
            <ng-template pTemplate="header">
                <span class="btnBars">
                    <i class="pi pi-replay" ></i>
                </span>
            </ng-template>
        </p-tabPanel>
    </p-tabView>
</ng-container>
<p-dialog header="Information details" [(visible)]="displayMoreInfo" [modal]="true" [responsive]="true"
  [style]="{width: '60vw'}">
  <div class="card">
    <div class="p-field p-formgrid p-grid">
      {{fullInfo?.description}}
    </div>
  </div>
  <p-footer>
    <button type="button" pButton (click)="displayMoreInfo=false" label="Cancel" class="p-button-secondary"></button>
  </p-footer>
</p-dialog>

<p-dialog header="{{POSheader}}" [(visible)]="displayDataTB" [modal]="true" [responsive]="true"
  [style]="{width: '60vw'}" class="custom-header">
  <div class="card">
    <div class="p-grid">
     <div class="p-col-6" *ngIf="this.POSheader === 'Mapped Data'" style="border-right: 2px solid #888;">
            <p-table [value]="product" responsiveLayout="scroll">
                <ng-template pTemplate="header">
                    <tr>
                        <th colspan="3">LionO Fields</th>
                    </tr>
                    <tr>
                        <th>Account ID</th>
                        <th>Account Name</th>
                        <th>Address</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-product>
                    <tr>
                        <td>{{product.accountId}}</td>
                        <td>{{product.accountName}}</td>
                        <td>{{product.accountAddress}}</td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
        <div class="p-col-6" *ngIf="this.POSheader === 'Mapped Data'">
            <p-table [value]="product" responsiveLayout="scroll">
                <ng-template pTemplate="header">
                    <tr>
                        <th colspan="3">POS Fields</th>
                    </tr>
                    <tr>
                        <th>Store ID</th>
                        <th>Store Name</th>
                        <th>Store Address</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-product>
                    <tr>
                        <td>{{product.storeId}}</td>
                        <td>{{product.storeName}}</td>
                        <td>{{product.storeAddress}}</td>
                    </tr>
                </ng-template>
            </p-table>
        </div>



        <div class="p-col-12" *ngIf="this.POSheader === 'POS Data'">
            <p-table [value]="posData" responsiveLayout="scroll">
                <ng-template pTemplate="header">
                    <tr>
                        <th colspan="3">POS Fields</th>
                    </tr>
                    <tr>
                        <th>Store ID</th>
                        <th>Store Name</th>
                        <th>Store Address</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-product>
                    <tr>
                        <td>{{product.storeId}}</td>
                        <td>{{product.storeName}}</td>
                        <td>
                            {{ product.address1 }}{{ product.address1 ? ', ' : '' }}
                            {{ product.address2 }}{{ product.address2 ? ', ' : '' }}
                            {{ product.city }}{{ product.city ? ', ' : '' }}
                            {{ product.state }}{{ product.state ? ', ' : '' }}
                            {{ product.zip }}
                                </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>
  </div>
  <p-footer>
    <button type="button" pButton (click)="displayDataTB=false" label="Cancel" class="p-button-secondary"></button>
  </p-footer>
</p-dialog>
